export default __webpack_public_path__ + "static/MAGNETIC LAMINATE-6fdec7231957f5712ea3ecf4a119adb8.webp";